/**
 * @file   src\features\Login.tsx
 * @brief  Login page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { React, useState, Button } from '../utils/thirdpartyComponents';
import { getFirebaseToken} from "../utils/FirebaseConfig";

// Login method.
const PushIosTest = () => {
  
    const [token, setToken] = useState<string>('');

  // Method to send otp to the mail address.
  const askForPermission = async () => {
    try {
        const permission = await Notification?.requestPermission();
        if (permission === "granted") {
            console.log("Notification permission granted. Requesting for token.");
            getFirebaseToken().then((firebaseToken: string | undefined) => {
                if (firebaseToken) {
                 // console.log(firebaseToken);
                  setToken(firebaseToken)
                }
              });
            // do something with the FCM token
        } else {
            console.log("Notification permission denied");
            // Handle denied permission
        }
    } catch(e) {
      console.log("here",e)
    }
  };



  return (
    <>
      <div className="cw-container">
        <div className="signin-block">
          <Button variant="primary" className="w-100" type="submit" onClick={() => {
                          askForPermission()
                        }}> Permission
          </Button>

          {token ? <div>{token}</div> : ''}
          </div>
      </div>
    </>
  );
};

export default PushIosTest;
